// File: src/data/carouselData.js

const items = [
  {
    src: "/img/news8.1.png",
    firstTitle: "PhotoGallery.gallery.surveillance1",
    secoundTitle: "PhotoGallery.gallery.surveillance2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/news8.2.png",
    firstTitle: "PhotoGallery.gallery.surveillance1",
    secoundTitle: "PhotoGallery.gallery.surveillance2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/news8.3.png",
    firstTitle: "PhotoGallery.gallery.surveillance1",
    secoundTitle: "PhotoGallery.gallery.surveillance2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/news8.4.png",
    firstTitle: "PhotoGallery.gallery.surveillance1",
    secoundTitle: "PhotoGallery.gallery.surveillance2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/sensor_4.jpg",
    firstTitle: "PhotoGallery.gallery.sensor1",
    secoundTitle: "PhotoGallery.gallery.sensor2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/sensor_2.jpg",
    firstTitle: "PhotoGallery.gallery.sensor1",
    secoundTitle: "PhotoGallery.gallery.sensor2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/sensor_3.jpg",
    firstTitle: "PhotoGallery.gallery.sensor1",
    secoundTitle: "PhotoGallery.gallery.sensor2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/drone_1.jpg",
    firstTitle: "PhotoGallery.gallery.dron1",
    secoundTitle: "PhotoGallery.gallery.dron2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/drone_2.jpg",
    firstTitle: "PhotoGallery.gallery.dron1",
    secoundTitle: "PhotoGallery.gallery.dron2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/drone3.jpg",
    firstTitle: "PhotoGallery.gallery.dron1",
    secoundTitle: "PhotoGallery.gallery.dron2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/vehicle-sq.jpg",
    firstTitle: "PhotoGallery.gallery.truck1",
    secoundTitle: "PhotoGallery.gallery.truck2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/vehicle1-sq.jpg",
    firstTitle: "PhotoGallery.gallery.truck1",
    secoundTitle: "PhotoGallery.gallery.truck2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
  {
    src: "/img/vehicle2-sq.jpg",
    firstTitle: "PhotoGallery.gallery.truck1",
    secoundTitle: "PhotoGallery.gallery.truck2",
    gradient: "linear-gradient(to left bottom, #2DB964, #14532D)",
  },
];

export default items;
